import styled from "@emotion/styled";
import type { FC, ReactElement, ReactNode, HTMLAttributes } from "react";
import React from "react";
import { tabBarHeight } from "src/constants/layout";

export const AnimatedPageWrapper = styled.main`
  label: AnimatedPage;
  min-height: calc(100% - ${tabBarHeight}px);
  width: 100%;
  flex: 1;
  height: 100%;
`;

interface AnimatedPageProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode | undefined;
}

/**
 * Base Page component that animates when it enters/exits from route change
 */
const AnimatedPage: FC<AnimatedPageProps> = ({
  children,
  ...props
}): ReactElement => {
  return <AnimatedPageWrapper {...props}>{children}</AnimatedPageWrapper>;
};

export default AnimatedPage;
